import { HTTP_STATUS_CODE } from '../../constants/apolloConfig';

/**
 * Whether an Apollo `networkError` represents a timeout.
 *
 * Two shapes reach us:
 *  - the server answering with a `TIME_OUT` extension code, and
 *  - `apollo-link-timeout` aborting the request client-side.
 *
 * The client-side case is matched on `statusCode`, not on `name`: the library's
 * `TimeoutError` extends `Error` without ever assigning `name`, so it arrives
 * named plain `'Error'`. The link is constructed with an explicit
 * `HTTP_STATUS_CODE.RequestTimeout` so this stays true regardless of the
 * library's own default.
 */
export const isTimeoutError = (networkError: { statusCode?: number } | undefined, errorCode: string): boolean =>
  errorCode === 'TIME_OUT' || networkError?.statusCode === HTTP_STATUS_CODE.RequestTimeout;
